import { Construction } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';

export default function AdminPlaceholder({ title }) {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#001A3E]">{title}</h1>
        <p className="text-gray-500">Fonksyon sa a ap vini byento</p>
      </div>
      
      <Card>
        <CardContent className="py-16 text-center">
          <Construction className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
          <h2 className="text-xl font-bold text-[#001A3E] mb-2">An Konstriksyon</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            Nou ap travay sou fonksyon sa a. Li pral disponib nan yon pwochèn mizajou.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

// Export specific placeholder pages
export function AdminCoupons() {
  return <AdminPlaceholder title="Coupon" />;
}

export function AdminShipping() {
  return <AdminPlaceholder title="Livrezon" />;
}

export function AdminReports() {
  return <AdminPlaceholder title="Rapò" />;
}

export function AdminReviews() {
  return <AdminPlaceholder title="Revi" />;
}

export function AdminNotifications() {
  return <AdminPlaceholder title="Notifikasyon" />;
}

export function AdminUsers() {
  return <AdminPlaceholder title="Itilizatè" />;
}
